/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

class PublicationDate extends React.Component {
  static propTypes = {
    date: PropTypes.string,
  };

  static defaultProps = {
    date: null,
  };

  render() {
    if (this.props.date) {
      const formattedDate = Moment(this.props.date).format('Do MMMM YYYY');
      return <time dateTime={this.props.date}>{formattedDate}</time>;
    }
    return null;
  }
}

export default PublicationDate;
